import {CanNegotiateInterface, CanStartNegotiateInterface} from "@/modules/diplomacy/interfaces";
import {Player, PlayerContractNegotiation} from "@/modules/team/entity";
import {Negotiation} from "@/modules/diplomacy/entity";
import WageCalculator from "@/modules/team/services/WageCalculator";
import {ConfigRepository} from "@/modules/base/services/ConfigRepository";

export default class PlayerContractNegotiationContainer implements CanNegotiateInterface, CanStartNegotiateInterface {
  public negotiations: Negotiation[] = [];

  constructor(
    private wageCalculator: WageCalculator,
    private configRepository: ConfigRepository,
    public player: Player,
    public years: number,
  ) {
  }

  get id(): number {
    return this.player.id;
  }

  get baseMonthlyPrice(): number {
    return this.wageCalculator.calculate(this.player);
  }

  get baseOncePrice(): number {
    return this.configRepository.get('players.contract.contractNegotiation.baseOncePrice')(this.player);
  }

  get greediness(): number {
    return this.player.greediness;
  }

  get patience(): number {
    return this.player.patience;
  }

  get resentfulness(): number {
    return this.player.resentfulness;
  }

  // todo: use config
  get playerTargetYears(): number {
    if (this.player.age <= 25) {
      return Math.min(5, this.player.contractYears! + 1);
    }

    if (this.player.age <= 27) {
      return Math.min(5, this.player.contractYears! + 2);
    }

    if (this.player.age <= 29) {
      return Math.min(5, this.player.contractYears! + 3);
    }

    return Math.min(5, this.player.contractYears! + 4);
  }

  async load(attr: "negotiations"): Promise<void> {
    this.negotiations = await PlayerContractNegotiation
      .createQueryBuilder('negotiation')
      .innerJoin('negotiation.target', 'player')
      .where('player.id = :playerId', {playerId: this.player.id})
      .getMany();
  }
}
